// extracted by mini-css-extract-plugin
module.exports = {"search-wrapper":"_1j9em","more-wrapper":"TnyyP","heading":"_1jIAD","heading-no-top-margin":"YR8CL","text-result":"_2uURA"};